import { withLayoutProps } from '@/utils/withLayoutProps';

import { StlyedDivider } from './styles';

export const Divider = withLayoutProps(({ ...props }) => <StlyedDivider {...props} />);
